import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'brn-form-switch',
  templateUrl: './form-switch.component.html',
  styleUrls: ['./form-switch.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormSwitchComponent),
      multi: true,
    },
  ],
})
export class FormSwitchComponent implements ControlValueAccessor {
  private $value!: boolean;

  get value(): boolean {
    return this.$value;
  }
  @Input()
  set value(val) {
    this.$value = val;
    this.onChange(this.$value);
  }

  @Input()
  size: 'regular' | 'small' = 'regular';

  onChange(_: any): any {}

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {}

  onClick(): void {
    this.value = !this.value;
  }
}
